import HttpClient from "../http/http_client";

export const getMatchRequest = async () => {
    try {
        const response = await HttpClient.get('match/');
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
}

export const getMatchByIdRequest = async (id) => {
    try{
        const response = await HttpClient.get(`match/${id}`);
        return {
            success : true, 
            data : response.data,
        }
    } catch(error) {
        if (error.response) {
            const {status, data} = error.respnse;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again."
        };
    }
}